import { isNil } from 'lodash';
import moment from 'moment';
const roundDays = number => Math.max(1, Math.ceil(number.toFixed(1)));
const pluralizeDay = (dayValue) => {
    if (dayValue === 1)
        return `${dayValue} day`;
    return `${dayValue} days`;
};
const toReadableValue = (timeEpoch, base = moment().unix()) => {
    if (isNil(timeEpoch)) {
        return 'No expiration';
    }
    if (timeEpoch < base) {
        return 'Expired';
    }
    const parsedTime = moment.unix(timeEpoch);
    const duration = moment.duration(parsedTime.diff(moment.unix(base)));
    const relativeDays = pluralizeDay(roundDays(duration.asDays()));
    return relativeDays;
};
const toEpochValue = (relativeValue, base = moment().unix()) => {
    if (relativeValue === 'No expiration')
        return undefined;
    const days = parseInt(relativeValue, 10);
    return moment.unix(base).add(days, 'days').unix();
};
const isExpired = (record) => isNil(record.expirationTime) || record.expirationTime >= Date.now() / 1000;
class LookupElementModelManipulator {
    toRelativeTime = toReadableValue;
    toEpochTime = toEpochValue;
    isExpired = isExpired;
    pluralizeDay = pluralizeDay;
}
export const lookupElementModelManipulator = new LookupElementModelManipulator();
//# sourceMappingURL=lookup-element.manipulator.js.map